import React, { useContext, useEffect, useState } from "react";
import MDModal from "components/MDModal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { LoginFormContext } from "context/LoginFormContext";
import { ModalContext } from "context/ModalContext";
import { MODULES } from "helpers/constant";
import UpdateStatus from "components/MDUpdateStatus";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import MDActionButton from "components/MDActionButton";
import { SEARCH_INPUT_TYPES } from "helpers/constant";
import moment from "moment";
import { DistrictContext } from "context/DistrictContext";
import { districtsListApi } from "Apis/member";
import { getDistrictDetailById } from "Apis/district";
import { districtDelete } from "Apis/district";
import DistrictForm from "./Form";

const DistrictList = () => {
  const { showMessageNotification, setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const {
    setNotification,
    modules,
    getModuleAccess,
    isLoading,
    setIsLoading,
    filterLoader,
    setFilterLoader,
    access,
  } = useContext(LoginFormContext);
  const { setEditData } = useContext(DistrictContext);
  const [district, setDistrict] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });

  const [filterVal, setFilterVal] = useState({
    name: "",
  });

  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
    setDefaultFilter((prev) => ({ ...prev, currentPage: 1 }));
  };

  let Obj = {
    ...defaultFilter,
    filters: {
      name: filterVal?.name,
      is_active: filterVal?.is_active?.value,
    },
  };

  const districtData = async (data) => {
    let response = await districtsListApi(Obj);
    filterLoader ? setIsLoading(false) : setIsLoading(true);
    if (response?.status === 200) {
      setDistrict(response?.data?.data?.rows);
      setRowCount(response?.data?.data?.count);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getModuleAccess(MODULES.DISTRICT);
  }, [modules]);

  useEffect(() => {
    districtData();
  }, [filterVal, defaultFilter]);

  const handleEditDelete = async (row, type) => {
    if (type === "Edit") {
      let response = await getDistrictDetailById(row.id);
      if (response?.status === 200) {
        setFilterLoader(false);
        setEditData(response?.data?.data);
        setOpen(true);
        setFormIsEdit(true);
      }
    }
    if (type === "Delete") {
      showMessageNotification({
        title: "Are you sure?",
        text: "You want to delete this member!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let deleteResponse = await districtDelete(row.id);
          if (deleteResponse?.status === 200) {
            setFilterLoader(false);
            setOpen(false);
            district?.length === 1 && setDefaultFilter({ ...defaultFilter, currentPage: 1 });
            districtData();
            setNotification({
              color: "success",
              icon: "check",
              title: "Success",
              content: deleteResponse.data.message,
              open: true,
            });
          } else {
            setNotification({
              color: "error",
              icon: "check",
              title: "error",
              content: deleteResponse.data.message,
              open: true,
            });
          }
        }
      });
    }
  };

  let data = {
    isFilter: true,
    columns: [
      {
        Header: "District Name",
        accessor: "name",
        minWidth: "85px",
        sort: true,
        filterLabel: "District Name",
        filterAccessor: "name",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value || "-"} />,
      },
      {
        Header: "Created date",
        accessor: "createdAt",
        sort: true,
        Cell: ({ value }) => (
          <DefaultCell value={value ? moment(value).format("DD-MM-YYYY hh:mm A") : "-"} />
        ),
      },
      {
        Header: "Status",
        accessor: "is_active",
        minWidth: "115px",
        filterLabel: "Status",
        filterAccessor: "is_active",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Active", value: "1" },
          { label: "Inactive", value: "0" },
        ],
        Cell: ({ row }) => (
          <UpdateStatus
            tableNameProp="districts"
            data={row}
            access={access?.write_access ? true : false}
          />
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        width: "12%",
        Cell: ({ value, row }) => (
          <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {access?.write_access && (
              <MDActionButton type="edit" onClick={() => handleEditDelete(row.original, "Edit")} />
            )}
            {access?.delete_access && (
              <MDActionButton
                type="delete"
                onClick={() => handleEditDelete(row.original, "Delete")}
              />
            )}
          </MDBox>
        ),
      },
    ],
    rows: district,
  };

  return (
    !isLoading && (
      <>
        <DashboardLayout>
          <DashboardNavbar />
          <>
            <MDModal
              hasButton={access?.write_access ?? false}
              btnText="add District"
              modalHead={`${formIsEdit ? "Edit" : "Add"} District`}
            >
              <DistrictForm districtData={districtData} />
            </MDModal>
            <DataTable
              table={data}
              isSorted={false}
              entriesPerPage={true}
              showTotalEntries={true}
              noEndBorder
              canFilter
              getDataList={districtData}
              rowCount={rowCount}
              //   canSearch={true}
              tableTitle="District List"
              defaultFilter={defaultFilter}
              setDefaultFilter={setDefaultFilter}
            />
          </>
        </DashboardLayout>
      </>
    )
  );
};
DistrictList.propTypes = {
  value: PropTypes.string,
  row: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  imageUrl: PropTypes.string.isRequired,
};
export default DistrictList;
